export const chats = {
  chatListChatIfoAttachmentsText: '첨부 파일 전송됨',
  chatListChatNoMessagesText: '아직 메시지가 없습니다',
  chatArchivedTitle: '보관된 채팅',
  chatsCreatePrivateCurtainTitle: '새로운 채팅',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: '검색',
  chatsCreatePrivateCurtainCreateButtonTitle: '생성',
  chatCreateButtonTitle: '다음',
  chatCreateNewGroupHeader: '새 그룹',
  chatGroupNameInputTitle: '그룹 이름',
  chatLogoTitle: '편집',
  chatCreateGroupButtonTitle: '그룹 만들기',
  chatRequiredFieldsAlert: '그룹 이름을 지정해야 합니다!',
  chatsCreateGroupChatLongTitleAlertText: '더 짧은 제목을 사용하세요!',
  chatsCreateGroupChatLBigImageAlertText: '더 작은 이미지를 선택하세요!',
  chatsNewChatInputPlaceholder: '메시지 작성',
  chatsNewChatAddedBigImageAlertText: '더 작은 이미지를 선택하세요!',
  chatOwnersArchiveOptionText: '보관',
  chatOwnersEditGroupOptionText: '편집',
  chatOwnersManageGroupOptionText: '멤버 관리',
  chatOwnersChangeGroupOptionText: '그룹 소유자 변경',
  chatOwnersLeaveGroupOptionText: '나가기',
  chatOwnersDeleteGroupOptionText: '채팅 삭제',
  chatpopupArchivedTitle: '보관된 채팅',
  chatpopupArchivedDescription: '확인하시겠습니까?',
  chatArchiveGroupButtonTitleYes: '확인',
  chatArchiveGroupButtonTitleCancel: '취소',
  chatEditGroupHeader: '채팅 편집',
  chatEditGroupEditLogoTitle: '편집',
  chatEditGroupButtonTitle: '저장',
  chatGroupEditAlertText: '저장 성공!',
  chatManageGroupHeader: '관리',
  chatManageGroupButtonTitle: '멤버 추가',
  chatManageGroupSaveButtonTitle: '저장',
  chatAddUsersGroupHeader: '멤버 추가',
  chatAddUsersGroupButtonTitle: '확인',
  chatAddUsersGroupSearchInputPlaceholder: '검색',
  chatOwnershipTransferHeader: '소유권 이전',
  chatOwnershipTransferSearchInputPlaceholder: '검색',
  chatOwnershipTransferButtonTitle: '확인',
  chatOwnerMarkText: '(당신)',
  chatOwnershipTransferAlertText: '소유권이 전송되었습니다!',
  chatOwnerLeaveGroupTitle: '그룹 나가기',
  chatOwnerLeaveGroupDescription: '당신은 채팅의 소유자이므로 나가기 전에 새로운 소유자를 지정해야 합니다.',
  chatOwnerLeaveGroupButtonTitleYes: '선택',
  chatOwnerLeaveGroupButtonTitleNo: '취소',
  chatsGroupChatUsersCurtanArchOptionTitle: '보관',
  chatsGroupChatUsersCurtanMembersOptionTitle: '채팅 멤버',
  chatsGroupChatUsersCurtanLeaveOptionTitle: '나가기',
  chatsGroupChatMemberCurtainTitle: '채팅 멤버',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: '검색',
  chatsGroupChatMemberCurtainOwnerMarkText: '(소유자)',
  chatsGroupChatLeavePopupTitle: '나가기',
  chatsGroupChatLeavePopupText: '확인하시겠습니까?',
  chatsGroupChatLeavePopupCancelButtonTitle: '취소',
  chatsGroupChatLeavePopupConfirmButtonTitle: '확인',
  chatDeleteGroupTitle: '채팅 삭제',
  chatDeleteGroupDescription: '모든 참가자에게 대화와 그 내역이 삭제됩니다. 계속하시겠습니까?',
  chatDeleteGroupButtonTitleYes: '확인',
  chatDeleteGroupButtonTitleNo: '취소',
  chatsPrivateChatCurtainArchOptionTitle: '보관',
  chatsEditMessage: '메시지 편집',
  chatsCopyMessage: '메시지 복사',
  chatsDeleteMessage: '메시지 삭제',
  chatsSelectMessage: '메시지 선택',
  chatMarkTextEdit: '(편집됨)',
  chatCopyMessageAlertText: '메시지가 복사되었습니다!',
  chatDeleteMessageTitle: '메시지 삭제',
  chatDeleteMessageDescription: '이 메시지를 삭제하시겠습니까?',
  chatDeleteMessageButtonTitleYes: '확인',
  chatDeleteMessageButtonTitleNo: '취소',
  chatSelectButtonDelete: '취소',
  chatSelectButtonNo: '삭제',
  chatDeleteMessagesTitle: '메시지 삭제',
  chatDeleteMessagesDescription: '이 메시지들을 삭제하시겠습니까?',
  chatDeleteMessagesButtonTitleYes: '확인',
  chatDeleteMessagesButtonTitleNo: '취소',
  chatArchiveButtonRestore: '복원',
  chatArchiveButtonNo: '삭제',
  chatNoUsersCurtainTitle: '어이쿠!',
  chatsNoUsersCurtainText: '당신 외에는 사용자가 없는 것 같습니다. 채팅을 시작하려면 친구를 초대하세요.',
  chatsNoUsersCurtainCancelButtonTitle: '취소',
  chatsNoUsersCurtainCopyButtonTitle: '앱 링크 복사',
  chatsAppLinkCopiedAlertText: '링크가 복사되었습니다!',
  chatsTooFewUsers: '채팅을 시작하려면 최소한 한 명의 사용자를 선택하세요!',
  chatsError: '문제가 발생했습니다!'
}
